import React from 'react';

import {
    Wrapper,
    InnerWrapper,
    LoaderWrapper,
    LoaderIcon
} from './styled';


export const Loader = (props) => (
    <Wrapper inline={props.inline}>
        <InnerWrapper>
            <LoaderWrapper>
                <LoaderIcon size={props.size}/>
                <LoaderIcon size={props.size}/>
                <LoaderIcon size={props.size}/>
            </LoaderWrapper>
        </InnerWrapper>
    </Wrapper>
);


export default Loader;
